import { computed } from 'vue'

import { EventStatusId, YesNoEnum } from '@collector/sportsapi-client-legacy'

import { useCompetition } from './useCompetition'

export const useEvent = () => {
  const { competition } = useCompetition()

  const event = computed(() => competition.value.season.stage.group.event)
  const eventTimestamp = computed(() => competition.value.timestamp)

  const isResultVerified = computed(
    () => event.value.verified_result === YesNoEnum.Yes,
  )

  const isStatsVerified = computed(
    () => event.value.is_stats_verified === YesNoEnum.Yes,
  )

  const hasEventCurrentStatus = (eventStatuses: Set<EventStatusId>) =>
    eventStatuses.has(event.value.status_id)

  return {
    event,
    eventTimestamp,
    hasEventCurrentStatus,
    isResultVerified,
    isStatsVerified,
  }
}
